<template xmlns:el-col="http://www.w3.org/1999/html">
  <div class="addition-accessories" v-loading.lock="fullscreenloading">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">我的报价单</el-breadcrumb-item>
        <el-breadcrumb-item><a @click="toSecond"> 产品配置组</a></el-breadcrumb-item>
        <el-breadcrumb-item><a @click="selectProduct"> 已添加产品</a></el-breadcrumb-item>
        <el-breadcrumb-item> 选择配件</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div ref="headtap">
      <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline">
        <el-row>
          <el-col :span="21" align="left">
            <el-form-item label="主机型号：">
              {{ hostName }}
            </el-form-item>
            <el-form-item label="总计：功耗">
              （<span class="f-blue">{{ productPriceFormat(null,null,totalDissipation) }}</span>)
            </el-form-item>
            <el-form-item label="价格">
              （<span class="f-blue">{{ productPriceFormat(null,null,totalPrice) }}</span>)
            </el-form-item>
            <el-form-item label="数量总计">
              （<span class="f-blue">{{ totalNumber }}</span>）
            </el-form-item>
            <el-form-item prop="lineProperty">
              <el-cascader
                v-model="formInline.lineProperty"
                class="el-input"
                :options="allLinePropertyMap"
                :show-all-levels="false"
                clearable
                :filterable="false"
                expand-trigger="hover"
                placeholder="产品分类"
                :props="{value: `propertyCode`,label: `propertyName`,children: `children`}" @change="searchByKeyWords"
              />
            </el-form-item>
            <el-form-item prop="keyWords">
              <el-input v-model="formInline.keyWords" placeholder="请输入产品型号" @keyup.enter.native="searchByKeyWords" />
            </el-form-item>
            <el-form-item prop="userCollection">
              <el-checkbox v-model="formInline.userCollection" true-label="userCollection" false-label=""
                           @change="searchByKeyWords"
              >
                我的收藏
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchByKeyWords">查询</el-button>
              <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="3" align="right">
            <el-form-item>
              <el-button type="primary" @click="goback">返回</el-button>
              <el-button type="primary" @click="save">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="clear" />
    </div>
    <table>
      <tr v-for="(item,j) in productRuleList" :key="j">
        <td style="text-align: left">
          <span style="color:red">产品【{{ item.productName }}】的配置建议为：{{ item.configurationadvice }}</span>
        </td>
      </tr>
    </table>
    <div class="table-select" ref="headtable">
      <el-table
        :data="tableData3"
        border
        style="width: 100%"
        :cell-style="changeStyle"
      >
        <el-table-column
          prop="productName"
          label="产品型号"
          min-width="20%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductNameFormation :scope="scope" />
          </template>
        </el-table-column>
        <el-table-column
          label="产品描述"
          align="left"
          min-width="30%"
        >
          <template slot-scope="scope">
            <long-text :text="scope.row.productDesc" />
          </template>
        </el-table-column>

        <el-table-column
          prop="productPrice"
          label="价格（元）"
          min-width="10%"
          align="center"
          :formatter="productPriceFormat"
        />
        <el-table-column
          prop="purchaseQuantity"
          label="数量/套"
          min-width="10%"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number size="mini" controls-position="right" @change="handleChange();getWeakCorrelation(scope.row.productCode,scope.row.purchaseQuantity)" v-model="scope.row.purchaseQuantity" :min="0" :precision="0" :max="scope.row.optionalType === 1 && scope.row.subPropertyName === '主机' ? 1 : 99999" style="width: 80px" />
          </template>
        </el-table-column>
        <el-table-column
          prop="productStatus"
          label="产品状态"
          min-width="8%"
          align="center"
        >
          <template slot-scope="scope">
            <ProductStatusFomation :scope="scope.row" />
            <!--<span v-if="scope.row.productStatus=='0'" style="color:#606266;">量产</span>-->
            <!--<span v-if="scope.row.productStatus=='1'" style="color: red;"><span v-if="scope.row.formalStopTime != null">{{scope.row.formalStopTime}}</span>停止下单</span>-->
            <!--<span v-if="scope.row.productStatus=='2'" style="color: red;">剩余库存清理</span>-->
          </template>
        </el-table-column>
        <el-table-column
          prop="powerDissipation"
          label="功耗（W）"
          min-width="8%"
          align="center"
        />
        <el-table-column
          prop="productType"
          label="类型，备货周期"
          min-width="8%"
          align="center"
        >
          <template slot-scope="scope">
            <ProductTypeFormation :scope="scope.row" />
            <!--{{scope.row.productType}}<span v-if="isNotNull(scope.row.productType)">类</span><span v-if="isNotNull(scope.row.productType)&&isNotNull(scope.row.deliveryPeriod)">，</span><span v-if="isNotNull(scope.row.deliveryPeriod)">{{scope.row.deliveryPeriod}}天</span>-->
          </template>
        </el-table-column>
        <el-table-column
          prop="productPscType"
          label="服务分类"
          min-width="3%"
          align="center"
        />
        <el-table-column
          label="特殊说明"
          align="left"
          min-width="30%"
        >
          <template slot-scope="scope">
            <long-text :text="notesTextFormat(scope.row.notes,scope.row.supplyRemarks)" />
          </template>
        </el-table-column>
        <el-table-column
          label="更多"
          min-width="5%"
          align="center"
        >
          <template slot-scope="scope">
            <MoreContent :scope="scope" :is-partner="isPartner" />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="4%"
          align="center"
        >
          <template slot-scope="scope">
            <ProductOperate :scope="scope" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

import Api from '../../api';
import longText from '../quotationlist/longText';
import { productPriceFormat, changeStyle } from '../../utils/numberFormater';
import MoreContent from '../selectproduct/MoreContent';
import { isPartnerM, isNotNull, isControlled, notesTextFormat } from '@/utils/mUtils';
import ProductOperate from '../components/ProductOperate';
import ProductNameFormation from '../components/ProductNameFormation';
import { ProductRule } from '@/utils/productRule';
import ProductStatusFomation from '../components/ProductStatusFomation';
import ProductTypeFormation from '../components/ProductTypeFormation';

export default {
  mixins: [ProductRule],
  data () {
    return {
      subId: '',
      tableData3: [],
      totalDissipation: 0,
      hostName: '',
      totalPrice: 0,
      groupId: '',
      totalNumber: 0,
      projectId: '',
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      loading3: true,
      groupName: '',
      formInline: {
        keyWords: '',
        region: '',
        lineProperty: [],
        userCollection: ''
      },
      isService: false,
      isPartner: true,
      allLinePropertyMap: [],
      loading: false,
      fullscreenloading: true
    };
  },
  components: { longText, MoreContent, ProductNameFormation, ProductOperate, ProductStatusFomation, ProductTypeFormation },
  methods: {
    productPriceFormat,
    changeStyle,
    isNotNull,
    isControlled,
    notesTextFormat,
    save () {
      this.fullscreenloading = true;
      let body = {
        subId: this.subId,
        list: this.tableData3
      };
      Api.saveChoosePartList(body)
        .then(result => {
          if (result.data.status === '200') {
            this.initPartsList();
            this.$message({
              showClose: true,
              duration: 800,
              message: '保存成功',
              type: 'success'
            });
          } else {
            this.$notify.error(result.data.msg);
          }
        })
        .catch(e => {
          this.fullscreenloading = false;
          this.$notify.error('网络异常');
          console.error('e', e);
        });
    },
    goback () {
      this.$router.push({ name: 'AddedProduct/added', params: { groupId: this.groupId, projectId: this.projectId, groupName: this.groupName } });
    },
    handleChange (productCode) {
      this.totalDissipation = 0;
      this.totalPrice = 0;
      this.totalNumber = 0;
      this.tableData3.forEach(item => {
        this.totalDissipation += item.powerDissipation * item.purchaseQuantity;
        this.totalPrice += item.productPrice * item.purchaseQuantity;
        this.totalPrice = Math.round(this.totalPrice * 100) / 100;
        this.totalNumber += item.purchaseQuantity;
      });
      this.fullscreenloading = false;
    },

    //     getProductRule(productCode){
    //       this.getWeakCorrelation(productCode);
    // },
    getHostName () {
      Api.getHostNameBySubId(this.subId)
        .then(result => {
          if (result.data.status == 200) {
            this.hostName = result.data.data;
            if (this.hostName == null) {
              this.hostName = '暂无';
            }
          } else {
            this.$notify.error(result.data.msg);
          }
        })
        .catch(error => {
          console.log(error);
          this.$notify.error('网络异常');
        });
    },
    // 点击导航 产品配置
    toSecond () {
      this.$router.push({ name: 'CreatOrderSecond/second', query: { projectId: this.projectId } });
    },
    // 点击导航 选择产品
    selectProduct () {
      // 509388693589463040?groupName=Site_1&projectId=509388693547524096
      this.$router.push({ name: 'AddedProduct/added', params: { groupId: this.groupId, projectId: this.projectId } });
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    productDesc (val) {
      let cont = '';
      if (this.screenWidth <= 1440) {
        cont = val.length > 35 ? val.substring(0, 35) : val;
        return cont;
      } else {
        cont = val.length > 40 ? val.substring(0, 40) : val;
        return cont;
      }
    },
    initPartsList () {
      this.fullscreenloading = true;
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.formInline.lineProperty && this.formInline.lineProperty.length > 0) {
        propertyCode = this.formInline.lineProperty[0];
        if (this.formInline.lineProperty.length == 2) {
          fieldFatherID = this.formInline.lineProperty[1];
        }
      }

      let param = {
        subId: this.subId,
        propertyCode: propertyCode,
        fieldFatherID: fieldFatherID,
        keyWords: this.formInline.keyWords,
        userCollection: this.formInline.userCollection
      };

      Api.getChoosePartList(param)
        .then(result => {
          if (result.data.status == 200) {
            // console.log(result.data.data);
            this.tableData3 = result.data.data;
            this.handleChange();
            this.loading3 = false;
          } else {
            this.$notify.error(result.data.msg);
            this.loading3 = false;
          }
        })
        .catch(e => {
          this.fullscreenloading = false;
          console.error('error ', e);
          this.$notify.error('网络异常');
        });
      // console.log("this.$route.params " , this.subId);
    },
    searchByKeyWords () {
      this.initPartsList();
    },
    checkValid (remarks) {
      if (remarks && remarks.trim().length > 0) {
        return true;
      } else {
        return false;
      }
      // return remarks.trim().length>0;
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.searchByKeyWords();
    },
    // 获取产品分裂列表
    getSubProperty () {
      let param = {
        params: {
          subId: this.subId
        }
      };
      Api.getSubProperty(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // console.log(this.allLinePropertyMap);
          this.allLinePropertyMap = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error('网络异常！');
      });
    }
  },
  mounted () {
    this.isPartner = isPartnerM();
    this.subId = this.$route.params.subId;
    this.groupId = this.$route.params.groupId;
    this.projectId = this.$route.params.projectId;
    this.groupName = this.$route.params.groupName;
    this.isService = this.$route.params.isService;

    this.getSubProperty();
    this.initPartsList();// 初始化配件列表
    this.getHostName();// 获取当前主机名称
    this.getHostValidate(this.subId);

    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    window.onscroll = () => {
      let height = document.documentElement.scrollTop || document.body.scrollTop;
      if (height > 95) {
        this.$refs.headtap.className = 'fixed';
        this.$refs.headtable.style.marginBottom = '150px';
      } else {
        this.$refs.headtap.className = '';
        this.$refs.headtable.style.marginBottom = '20px';
      }
    };
  },
  destroyed () {
    window.onscroll = null;
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val;
    }
  }
};
</script>

<style type="text/css">

  @import "../../styles/product-common.css";

  .clearfloat{
    clear: both;
  }

  .addition-accessories .el-form-item{
    margin-bottom: 0px;
    margin-right: 0px;
  }

  .addition-accessories .table{
    margin-top: 40px;
  }

  .addition-accessories .table-select .el-table .cell{
    white-space:normal;
  }

  .addition-accessories .blue-btn {
    background: #36BADE;
    width: 120px;
    height: 32px;
    color: #FFFFFF;
    border-radius: 5px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 0;
  }

  .addition-accessories .table-select{
    /*margin-top: 2rem;*/
    margin-bottom: 100px;
  }

  .addition-accessories .grid-content{
    float: left;
    margin-right: 20px;
  }

  .clear{
    clear: both;
  }

  .addition-accessories .grid-content:last-of-type{
    margin-right: 0;
  }

  .addition-accessories .promotion{
    width: 30px;
    height: 100%;
    display: inline-block;
  }
  .addition-accessories .promotion img{
    width: 24px;
    vertical-align: middle;
  }

  .addition-accessories .promotion:hover img{
    width: 28px;
  }

  .addition-accessories .fixed{
    position: fixed;
    width: 100%;
    background: #ffffff;
    z-index: 1000;
    top: 0;
    padding: 20px 48px 20px 0;
  }

  @media screen and (max-width: 1366px) {
    .addition-accessories .crumbs-navigation{
      padding-top: 15px;
    }

    .addition-accessories table tr,
    .addition-accessories table tr th,
    .addition-accessories table tr td ,
    .addition-accessories table tr td .el-button--text{
      height: 3rem;
      font-size: 1.2rem;
      padding: 0;
      margin: 0;
    }

    .addition-accessories table tr td{
      padding: 0;
    }

    .addition-accessories .table-select {
      margin-top:0;
    }

    .addition-accessories .grid-content{
      margin-right: 10px;
    }
  }
  @media screen and (max-width: 1280px) {

  }

</style>
